import { Platform } from 'react-native';
import { useFocusEffect as useFE } from '@react-navigation/native';
import { EffectCallback } from 'react';

const useFocusEffect = (callback: EffectCallback) => {
  useFE(callback);
};

export default Platform.OS !== 'web' ? useFocusEffect : () => {};
